declare var jQuery: any;

import { Component, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core'
import { Subscription } from 'rxjs'
import { MessageService, MessageOptions } from '../../services/message/message.service'

// import * as $ from 'jquery'
import '@burt-ui/semantic/definitions/modules/transition.js'

@Component({
  selector: 'message',
  template:
    `<div #elementRef class="ui icon message hidden" [ngClass]="type">
      <i (click)="hide()" class="close icon"></i>
      <i *ngIf="icon" class="icon" [ngClass]="icon"></i>
      <div class="content">
        <div class="header">{{title}}</div>
        <div *ngIf="errorInfo" class="error-info">{{errorInfo}}</div>
        <p [innerHTML]="message"></p>
        <div *ngIf="xRayId" class="ui divider"></div>
        <span *ngIf="xRayId" class="extras">Reference Code: {{xRayId}}</span>
      </div>
    </div>`,
  styles:
  [`
    .ui.message {
      position: fixed;
      top: 5px;
      width: 50% !important;
      margin-left: 25%;
      z-index: 100000;

      .error-info {
        margin-top: 10px;
        font-weight: bold;
      }

      .extras {
        font-size: 12px;
      }
    }
  `]
})
export class MessageComponent implements AfterViewInit, OnDestroy {
  @ViewChild('elementRef') elementRef: ElementRef
  $element
  subscriptions: Subscription[]

  type: string
  icon: string
  title: string
  message: string
  xRayId: string
  errorInfo: string;

  constructor(private messageService: MessageService) { }

  ngAfterViewInit() {
    this.$element = $(this.elementRef.nativeElement)

    this.subscriptions = [
      this.messageService.showEvent.subscribe( ({ title, message, options }) => this.show(title, message, options) ),
      this.messageService.hideEvent.subscribe(() => this.hide()),
    ]
  }

  isVisible() {
    return this.$element && this.$element.is(':visible') || false
  }

  show(title: string, message: string, { type, icon, xRayId, errorInfo }: MessageOptions) {
    this.title = title
    this.message = message
    this.type = type
    this.icon = icon
    this.xRayId = xRayId?.replace('Root=', '')
    this.errorInfo = errorInfo;

    if (!this.isVisible()) {
      this.$element.transition('fade')
    }
  }

  hide() {
    if (this.isVisible()) {
      this.$element.transition('fade')
    }
  }

  ngOnDestroy() {
    this.subscriptions?.forEach(subscription => subscription.unsubscribe())
  }
}
